import { useStepContext } from '~/app/providers/paymentStepProvider';

import { Typography } from '../Typography/Typography';

import { Icon, Root, TitleWrapper } from './Header.ui';
import { BackIcon } from './icons/BackIcon.ui';
import { CloseIcon } from './icons/CloseIcon.ui';

type HeaderType = 'close' | 'back';

const iconConfig: Record<HeaderType, React.ReactElement> = {
  back: <BackIcon />,
  close: <CloseIcon />,
};

export const Header = ({
  type,
  title,
  onClick,
  leftIconSlot,
}: {
  type?: HeaderType;
  title: string;
  onClick?: VoidFunction;
  leftIconSlot?: React.ReactNode;
}) => {
  const { goBack } = useStepContext();

  const handleIconClick = () => {
    if (onClick) {
      onClick();

      return;
    }
    if (type === 'back') {
      goBack();
    }
  };

  return (
    <Root>
      <Icon onClick={handleIconClick} tabIndex={0} type="button">
        {type && iconConfig[type]}
      </Icon>
      <TitleWrapper>
        {leftIconSlot}
        <Typography.H2>{title}</Typography.H2>
      </TitleWrapper>
    </Root>
  );
};
